module.exports = __webpack_public_path__ + "static/media/content-1.c76a07aa.png";